import { type Mutation } from '@pkg/graphql/codegen/graphql';
import { collectiblesHide, collectiblesShow } from '@pkg/graphql/mutations';

import { apiReturnResults, Request } from '@app/client';

import { type HideCollectiblesParams, type ShowCollectiblesParams } from './request.types';

async function hideCollectibles(params: HideCollectiblesParams): Promise<Mutation> {
    return Request.graphqlMutation({
        ...params,
        query: collectiblesHide,
        apiSettingsType: 'marketplace',
    });
}

async function showCollectibles(params: ShowCollectiblesParams): Promise<Mutation> {
    return Request.graphqlMutation({
        ...params,
        query: collectiblesShow,
        apiSettingsType: 'marketplace',
    });
}

export const callHideCollectibles = (params: { variables: HideCollectiblesParams }) =>
    apiReturnResults(hideCollectibles, params);
export const callShowCollectibles = (params: { variables: ShowCollectiblesParams }) =>
    apiReturnResults(showCollectibles, params);
